const layers = [
  {
    "type": "overlayers",
    "name": "Sobreposições",
    "visible": true,
    "layers": [
      {
        "id": 2736,
        "name": "Ponto receptor e bacia de lançamentos de efluentes",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:group_ete",
          "STYLES": "pgw-group_ete",
          "SRS": "EPSG:4326",
          "VIEWPARAMS": "locationid:1217"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.9,
          "visible": true,
          "zindex": 0
        },
        "hide_on_menu": true,
      },
      {
        "id": 2737,
        "name": "Pontos de lançamento de efluentes",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:pontoreceptor",
          "STYLES": "pgw-ete-effluent_receiving_point",
          "ENV": "circle_fill_color:FFAB7A"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "event_params": {
          "type": "click",
        },
        "tooltip_params": {
          "KEYS": [
            /* "rcpete",
            "citname",
            "rcpnome" */
            '{"key": "rcpete,citname,rcpnome", "label_title": "ETE"}',
          ],
          "FORMAT": "ETE {0} - {1} - {2}",
        },
        "property_params": {
          "opacity": 0.9,
          "visible": false,
          "zindex": 2
        },
        "icon_params":{
          "class": "icon-infohidro-pontos-efluentes",
          "background_color": "#FFAB7A"
        },
      },
      {
        "id": 661,
        "name": "Bacias receptoras de efluentes",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?sortby=sbsarea+d",
        "url_params": {
          "LAYERS": "forecastdev:customer_subbasin",
          "STYLES": "pgw_polygon_env",
          "ENV": "stroke_color:D97066;fill_color:FFF;stroke_width:1;fill_opacity:0.05",
          "CQL_FILTER": "bacid=17",
          "VIEWPARAMS": "customer_id:7"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "event_params": {
          "type": "click",
        },
        "tooltip_params": {
          "KEYS": [
            '{"key": "sbsacronym,sbsname", "label_title": ""}',
            '{"key": "d1", "label": "Vazão", "suffix": "m³/s"}',
          ],
          "FORMAT": "{0}<br>{1}",
          "icon_params":{
            "class": "icon-infohidro-bacia",
            "background_color": "#D97066"
          },
        },
        "property_params": {
          "opacity": 0.9,
          "visible": false,
          "zindex": 1,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(217, 112, 102, 0.5)',
            "strokeColor": '#D97066'
          },
        }
      },
    ]
  },
  {
    "type": "grouping",
    "name": "Hidrografia",
    "visible": true,
    "layers": [
      {
        "id": 695,
        "name": "Rios de captação",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:rioprincipalcaptacao",
          "STYLES": "pgw-linestring_env",
          "env": "stroke:0583F2"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "rpcname", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 696,
        "name": "Rios de lançamentos de efluentes",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:rioprincipallancamento",
          "STYLES": "pgw-linestring_env",
          "env": "stroke:E17536"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "rplname", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 683,
        "name": "Hidrografia do Paraná",
        "url": "https://produtos.simepar.br/geosimepar/shape/wms?",
        "url_params": {
          "LAYERS": "shape:hidrografia_iat"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "nooriginal", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 748,
        "name": "Grandes bacias do Paraná",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:bacias_hidrograficas_parana",
          "STYLES": "pgw-polygon_env",
          "ENV": "fill_color:023373;stroke_color:023373;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "nome_bh", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(2, 51, 115, 0.6)',
            "strokeColor": '#023373',
          },
        }
      },
      {
        "id": 747,
        "name": "Unidades hidrográficas oficiais",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:unidades_hidrograficas_parana",
          "STYLES": "pgw-polygon_env",
          "ENV": "fill_color:0583F2;stroke_color:0583F2;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "nome_uh", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(5, 131, 242, 0.6)',
            "strokeColor": '#0583F2',
          },
        }
      },
      {
        "id": 767,
        "name": "Aquíferos",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:aquiferoaflorante"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "saanome", "label_title": ""}',
            '{"key": "saatipo", "label": "Tipo", "icon_label":"mdi-texture-box"}',
          ],
          "FORMAT": "{0} ({1})"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          alwaysVisible: false,
          vertical: true,
          groupItems:[
              {
                  text: "Cárstico",
                  items:[
                      { text:'Carste da Bacia do Paraná' ,color:'#F2AB43', style: 'square'},
                  ]
              },
              {
                  text: "Fraturado",
                  items:[
                      { text:'Fraturado Centro-Sul' ,color:'#C0FF43', style: 'square' },
                      { text:'Serra Geral' ,color:'#79BA43', style: 'square' },
                  ]
              },
              {
                text: "Poroso",
                items:[
                    { text:'Alexandra - Guaraqueçaba' ,color:'#96E6FE', style: 'square' },
                    { text:'Bateias - Campo Alegre' ,color:'#8EDEF8', style: 'square' },
                    { text:'Bauru-Caiuá' ,color:'#8CDAF6', style: 'square' },
                    { text:'Cananéia' ,color:'#82CFF0', style: 'square' },
                    { text:'Castro' ,color:'#80CDEE', style: 'square' },
                    { text:'Ervalzinho' ,color:'#77C1E7', style: 'square' },
                    { text:'Furnas' ,color:'#76BCE3', style: 'square' },
                    { text:'Guabirotuba' ,color:'#72B8E1', style: 'square' },
                    { text:'Guarani' ,color:'#74BBE3', style: 'square' },
                    { text:'Itararé' ,color:'#6CB2DD', style: 'square' },
                    { text:'Palermo' ,color:'#5EA1D2', style: 'square' },
                    { text:'Passa Dois' ,color:'#5A9BCE', style: 'square' },
                    { text:'Ponta Grossa' ,color:'#5592CB', style: 'square' },
                    { text:'Rio Bonito' ,color:'#508FC8', style: 'square' },
                    { text:'Litorâneo Nordeste - Sudeste' ,color:'#436EB0', style: 'square' },
                ]
              },
          ]
        },
      },
      {
        "id": 768,
        "name": "Estágio de Seca",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:escassez sanepar",
          "CQL_FILTER": "ehdref='ETE'",
          "STYLES": "escassez_hidrica_style"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          "alwaysVisible": true,
          "vertical": true,
          "groupItems": [{
            "items":[
                { "text":"Emergência", "color": "#9B44B1" },
                { "text":"Crítica", "color":"#FF0000" },
                { "text":"Alerta", "color":"#FFA500" },
                { "text":"Atenção", "color":"#FFFF00" },
                { "text":"Normal", "color":"#008000" }
            ]
          }]
        }
      }
    ]
  }
];

export default layers;
